import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lead" }
const _hoisted_2 = { class: "lead__row" }
const _hoisted_3 = { class: "lead__main" }
const _hoisted_4 = { class: "lead__col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_card_84 = _resolveComponent("content-card-84")!
  const _component_widget_block = _resolveComponent("widget-block")!

  return (_openBlock(), _createBlock(_component_widget_block, {
    class: _normalizeClass(["widget-block--8-4", { 'widget-block--featured': _ctx.backgroundUrl }]),
    "background-url": _ctx.backgroundUrl
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.bigContent)
              ? (_openBlock(), _createBlock(_component_content_card_84, _mergeProps({ key: 0 }, _ctx.decorateContent(_ctx.bigContent), {
                  "lead-cropping": false,
                  size: 'large',
                  "show-border": false,
                  "show-lead": false
                }), null, 16))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondColContents, (content, i) => {
              return (_openBlock(), _createBlock(_component_content_card_84, _mergeProps({
                class: "news-card--secondColContents",
                key: i,
                "show-border": true,
                "show-fadeout": false,
                "title-highlighted": false
              }, _ctx.decorateContent(content)), null, 16))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["background-url", "class"]))
}